import { render, staticRenderFns } from "./lease-amendments-form.vue?vue&type=template&id=221cc3c4&"
import script from "./lease-amendments-form.vue?vue&type=script&lang=js&"
export * from "./lease-amendments-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports